import React, { ReactNode } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import produce from 'immer';
import Scroll from 'react-scroll';
import ReactGA from 'react-ga';

import ContentSetting01 from './ContentSetting01';

import SearchInputContainer from '../../containers/common/SearchInputContainer';
import Logo from '../../assets/bi/aivory-bi@2x.png';
import LogoColor from '../../assets/bi/aivory-bi-color@2x.png';
import MainBack from '../../assets/image/img_bg1.jpg';
import MainBack2 from '../../assets/image/img_bg2.jpg';
import IconSetting from '../../assets/icon/ic-setting@2x.png';
import IconSettingGray from '../../assets/icon/ic-setting-gray@2x.png';
import IconScrollDown from '../../assets/icon/ic-scroll-down@2x.png';
import { mainState } from '../../modules/main';
import { GetTotalRecommendParamType } from '../../lib/main/type.js';

import { media } from '../common/Layout';
import { PostConsumptionBodyType } from '../../lib/common/type';

const { scroller, Element } = Scroll;

interface styleType {
  isFocus?: boolean;
  isSettingMenuClick?: boolean;
  set0?: boolean;
  set1?: boolean;
  set2?: boolean;
  browserHeight?: number;
}

const RootComponent = styled.div`
  height: 100%;
  width: 100%;
`;

const MainComponent = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  transition: all 0.5s ease-out;
  -webkit-transition: all 0.5s ease-out;
  ${(props: styleType) => {
    if (props.set0) {
      return css`
        background-image: url(${MainBack});
      `;
    }
    if (props.set1) {
      return css`
        background-image: url(${MainBack2});
      `;
    }
    if (props.set2) {
      return css`
        min-height: 200px;
      `;
    }
    return css`
      background-image: url(${MainBack});
    `;
  }}
`;

const NavForm = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;

  /* Mobile Device */
  position: static;
  flex-direction: column;
  padding-left: 16px;
  padding-right: 16px;

  ${media.desktop`  
    position: relative;
    flex-direction: flex-start;
    padding-left: 0px;
    padding-right: 0px;
  `};
`;

const LogoBox = styled.div`
  max-width: 1070px;
  width: 100%;
  display: flex;
  height: 32px;

  /* Mobile Device */
  position: static;
  justify-content: center;
  margin-bottom: 26px;

  ${media.desktop`  
    position: absolute;
    justify-content: space-between;
    margin-bottom: 0px;
  `};
`;

const LogoImg = styled.img`
  height: 32px;
`;

const SettingBox = styled(Dropdown)`
  display: flex;
  align-items: center;

  /* Mobile Device */
  position: absolute;
  top: 15px;
  right: 13px;

  ${media.desktop`  
    position: static;
    margin-right: 80px;
  `};
`;
const SettingImg = styled.img`
  margin-left: 6px;
  cursor: pointer;

  /* Mobile Device */
  width: 26px;
  height: 26px;

  ${media.desktop`  
    width: 20px;
    height: 20px;
  `};
`;
const SettingBoxTitle = styled.div`
  font-family: 'NotoKrR';
  font-size: 14px;
  color: white;
  cursor: pointer;

  /* Mobile Device */
  display: none;

  ${media.desktop`  
    display: flex;
  `};
  ${(props: styleType) => {
    if (props.set2) {
      return css`
        color: #555555;
      `;
    }
    return css``;
  }}
`;
const SettingButton = styled(DropdownToggle)`
  display: flex;
  background-color: transparent;
  border: none;
  padding-left: 0px;
  :hover {
    background-color: transparent;
    border: none;
    color: #555555;
  }
  :focus {
    background-color: transparent;
    border: none;
    color: #555555;
    outline: none;
    box-shadow: none;
  }
`;
const SettingMenu = styled(DropdownMenu)`
  border-radius: 8px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  padding-top: 15px;
  padding-bottom: 6px;

  /* Mobile Device */
  width: 130px;
  left: -60px !important;

  ${media.desktop` 
    width: 170px;
    left: 0px !important;
  `};
`;
const SettingMenuTitle = styled.div`
  display: flex;
  align-items: center;
  font-family: 'NotoKrB';
  color: #90adb1;
  font-size: 12px;
  margin-bottom: 12px;
  padding-left: 20px;
  padding-right: 20px;
`;
const SettingMenuItem = styled.div`
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  align-items: center;
  font-family: 'NotoKrM';

  height: 31px;
  cursor: pointer;
  color: #555555;

  /* Mobile Device */
  font-size: 13px;

  ${media.desktop` 
    font-size: 14px;
  `};

  ${(props: styleType) => {
    if (props.isSettingMenuClick) {
      return css`
        text-decoration: underline;
        color: #000000;
        background-color: rgba(0, 0, 0, 0.1);
      `;
    }
    return css``;
  }}
`;

const CopyRight = styled.div`
  display: flex;
  position: absolute;
  bottom: 50px;
`;
const CopyRightText = styled.div`
  font-family: 'NotoKrR';
  color: white;

  /* Mobile Device */
  font-size: 13px;

  ${media.desktop` 
    font-size: 16px;
  `};
`;

const BlurBox = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  bottom: 0px;
  width: 100%;
  height: 60px;
  -webkit-backdrop-filter: blur(10.2px);
  backdrop-filter: blur(10.2px);
`;

const BlurBoxTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'NotoKrM';
  color: white;
  border-bottom: 3px solid #1f88e5;

  /* Mobile Device */
  width: 100px;
  font-size: 13px;

  ${media.desktop` 
    width: 200px;
    font-size: 16px;
  `};
`;

const tongtong = keyframes`
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-20px);
  }
`;

const BlurBoxImg = styled.img`
  position: absolute;

  cursor: pointer;
  -webkit-animation: ${tongtong} 1s infinite alternate;
  animation: ${tongtong} 1s infinite alternate;

  /* Mobile Device */
  height: 36px;
  bottom: 72px;

  ${media.desktop` 
    height: 56px;
    bottom: 100px;
  `};
`;

interface MainProps {
  onSetSettingId: (settingId: mainState['settingId']) => void;
  onGetTotalRecommend: (info: GetTotalRecommendParamType) => void;
  onPostConsumption: (info: PostConsumptionBodyType) => void;
  settingId: mainState['settingId'];
  totalRecommendData: mainState['totalRecommendData'];
  popularContentsData: mainState['popularContentsData'];
  wordCloudData: mainState['wordCloudData'];
}

interface MainState {
  isSettingOpen: boolean;
  settingCategory: {
    id: number;
    text: string;
    active: boolean;
  }[];
  browserHeight: number;
}

class Main extends React.PureComponent<MainProps, MainState> {
  state: MainState = {
    isSettingOpen: false,
    settingCategory: [
      { id: 0, text: '심플', active: true },
      { id: 1, text: '콘텐츠형 1', active: false },
      { id: 2, text: '콘텐츠형 2', active: false },
    ],
    browserHeight: window.innerHeight,
  };

  componentDidMount() {
    const { onSetSettingId } = this.props;
    const mainSettingId = localStorage.getItem('aivory_main_setting_id');
    if (!mainSettingId) {
      localStorage.setItem('aivory_main_setting_id', '0');
    }
    this.setState(
      produce((draft: MainState) => {
        draft.settingCategory.forEach((element) => {
          const tempElement = element;
          if (
            element.id ===
            Number(localStorage.getItem('aivory_main_setting_id'))
          ) {
            tempElement.active = true;
            localStorage.setItem('aivory_main_setting_id', `${element.id}`);
            onSetSettingId(element.id);
            ReactGA.ga('send', 'event', `view_main_home_${element.id}`);
          } else {
            tempElement.active = false;
          }
        });
      })
    );
    window.addEventListener('resize', () => {
      this.setState({
        browserHeight: window.innerHeight,
      });
    });
  }

  MoveToScroll = () => {
    scroller.scrollTo(`aivoryFeed`, {
      duration: 1500,
      delay: 100,
      smooth: true,
      offset: 0,
    });
  };

  toggleSetting = () => {
    const { isSettingOpen } = this.state;
    this.setState({
      isSettingOpen: !isSettingOpen,
    });
  };

  onClickSetting = (id: number) => {
    const { onSetSettingId } = this.props;
    this.setState(
      produce((draft: MainState) => {
        draft.settingCategory.forEach((element) => {
          const tempElement = element;
          if (element.id === id) {
            tempElement.active = true;
            localStorage.setItem('aivory_main_setting_id', `${element.id}`);
            onSetSettingId(element.id);
            ReactGA.ga(
              'send',
              'event',
              `click_main_option_list_button_${element.id}`
            );
            ReactGA.ga('send', 'event', `view_main_home_${element.id}`);
          } else {
            tempElement.active = false;
          }
        });
      })
    );
  };

  makeSettingComponent = (): ReactNode[] | null => {
    const {
      onGetTotalRecommend,
      onPostConsumption,
      settingId,
      popularContentsData,
      totalRecommendData,
      wordCloudData,
    } = this.props;
    const resultReactNode: ReactNode[] | null = [];
    switch (settingId) {
      case 0:
        resultReactNode.push(null);
        break;
      case 1:
        resultReactNode.push(
          <ContentSetting01
            // onGetTotalRecommend={onGetTotalRecommend}
            onPostConsumption={onPostConsumption}
            key={settingId}
            totalRecommendData={totalRecommendData}
            popularContentsData={popularContentsData}
            wordCloudData={wordCloudData}
          />
        );
        break;
      case 2:
        resultReactNode.push(
          <ContentSetting01
            // onGetTotalRecommend={onGetTotalRecommend}
            onPostConsumption={onPostConsumption}
            key={settingId}
            totalRecommendData={totalRecommendData}
            popularContentsData={popularContentsData}
            wordCloudData={wordCloudData}
          />
        );
        break;

      default:
        break;
    }
    return resultReactNode;
  };

  render() {
    const { isSettingOpen, settingCategory, browserHeight } = this.state;

    return (
      <RootComponent>
        <MainComponent
          set0={settingCategory[0].active}
          set1={settingCategory[1].active}
          set2={settingCategory[2].active}
          // browserHeight={browserHeight}
        >
          <NavForm>
            <LogoBox>
              {settingCategory[2].active ? (
                <LogoImg src={LogoColor} alt="aivory logo" />
              ) : (
                <LogoImg src={Logo} alt="aivory logo" />
              )}

              <SettingBox isOpen={isSettingOpen} toggle={this.toggleSetting}>
                <SettingButton
                  onClick={() => {
                    ReactGA.ga('send', 'event', `click_main_option_button`);
                  }}
                >
                  <SettingBoxTitle set2={settingCategory[2].active}>
                    설정하기
                  </SettingBoxTitle>
                  {settingCategory[2].active ? (
                    <SettingImg src={IconSettingGray} />
                  ) : (
                    <SettingImg src={IconSetting} />
                  )}
                </SettingButton>
                <SettingMenu>
                  <SettingMenuTitle>페이지 레이아웃</SettingMenuTitle>
                  <SettingMenuItem
                    isSettingMenuClick={settingCategory[0].active}
                    onClick={() => {
                      this.onClickSetting(0);
                    }}
                  >
                    심플
                  </SettingMenuItem>
                  <SettingMenuItem
                    isSettingMenuClick={settingCategory[1].active}
                    onClick={() => {
                      this.onClickSetting(1);
                    }}
                  >
                    콘텐츠형 1
                  </SettingMenuItem>
                  <SettingMenuItem
                    isSettingMenuClick={settingCategory[2].active}
                    onClick={() => {
                      this.onClickSetting(2);
                    }}
                  >
                    콘텐츠형 2
                  </SettingMenuItem>
                </SettingMenu>
              </SettingBox>
            </LogoBox>
            <SearchInputContainer urlParam="result" />
          </NavForm>
          {settingCategory[1].active ? (
            <BlurBox>
              <BlurBoxTitle>AI추천 피드</BlurBoxTitle>
              <BlurBoxImg
                src={IconScrollDown}
                onClick={() => {
                  this.MoveToScroll();
                }}
              />
            </BlurBox>
          ) : null}
          {settingCategory[0].active ? (
            <CopyRight>
              <CopyRightText>
                Copyright 2020. Nerdfactory. All rights reserved.
              </CopyRightText>
            </CopyRight>
          ) : null}
        </MainComponent>
        <Element name="aivoryFeed" />
        {this.makeSettingComponent()}
      </RootComponent>
    );
  }
}

export default Main;
